import { CountryFlag } from '@components'

import { TabButtonsGroup } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'

import { Language } from '../../../../types/language'
import { useSignupGuide } from '../../context/signupGuideContext'
import * as Styled from './styles'

interface LanguageData {
  value: Language
  flagIcon: () => ReactElement
}

const languages: LanguageData[] = [
  { value: 'da', flagIcon: () => <CountryFlag countryCode="dk" /> },
  { value: 'en', flagIcon: () => <CountryFlag countryCode="us" /> },
  { value: 'fr', flagIcon: () => <CountryFlag countryCode="fr" /> },
  { value: 'de', flagIcon: () => <CountryFlag countryCode="de" /> },
  { value: 'nl', flagIcon: () => <CountryFlag countryCode="nl" /> },
]

export const LanguageSwitcher = (): ReactElement | null => {
  const { language, setLanguage, isInternalFlow, isInternalUmbrellaFlow } = useSignupGuide()

  const handleClick = useCallback(
    (value: Language) => () => {
      setLanguage(value)
    },
    [setLanguage],
  )

  if (isInternalFlow || isInternalUmbrellaFlow) {
    return null
  }

  return (
    <Styled.LanguageSwitcherWrapper>
      <TabButtonsGroup size="sm">
        {languages.map(({ value, flagIcon: FlagIcon }) => (
          <TabButtonsGroup.Button key={value} size="sm" onClick={handleClick(value)} selected={language === value}>
            <Styled.IconWrapper>
              <FlagIcon />
            </Styled.IconWrapper>
          </TabButtonsGroup.Button>
        ))}
      </TabButtonsGroup>
    </Styled.LanguageSwitcherWrapper>
  )
}
